import React, { Component } from "react";
import {
    Box,
    Grid,
    Typography,
    Paper,
    Button,
    LinearProgress,
    Container,
    Divider,
} from "@mui/material";

import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import DownloadIcon from "@mui/icons-material/Download";
import StorageIcon from "@mui/icons-material/Storage";
import FlashOnIcon from "@mui/icons-material/FlashOn";
import SecurityIcon from "@mui/icons-material/Security";
import SpeedIcon from "@mui/icons-material/Speed";

import { ClipLoader } from "react-spinners";

class DownloadSection extends Component {
    state = {
        isDownloading: false,
        downloadProgress: 0,
    };

    handleDownload = () => {
        this.setState({
            isDownloading: true,
            downloadProgress: 0,
        });

        let progress = 0;

        const interval = setInterval(() => {
            progress += 10;

            if (progress > 100) progress = 100;

            this.setState({
                downloadProgress: progress,
            });

            if (progress === 100) {
                clearInterval(interval);

                setTimeout(() => {
                    this.setState({
                        isDownloading: false,
                        downloadProgress: 0,
                    });
                }, 500);
            }
        }, 250);
    };

    render() {
        const { isDownloading, downloadProgress } = this.state;

        return (
            <Box
                sx={{
                    position: "relative",
                    overflow: "hidden",
                    background:
                        "linear-gradient(145deg,#F1F8F0 0%,#F8FCF6 48%,#EAF4E8 100%)",
                    py: { xs: 8, md: 13 },
                    minHeight: "100vh",
                }}
            >
                {/* BACKGROUND DECORATION */}
                <Box
                    sx={{
                        position: "absolute",
                        width: { xs: 250, md: 500 },
                        height: { xs: 250, md: 500 },
                        borderRadius: "50%",
                        background:
                            "radial-gradient(circle,rgba(65,190,105,0.12) 0%,rgba(65,190,105,0) 70%)",
                        top: -180,
                        left: -150,
                        pointerEvents: "none",
                    }}
                />

                <Box
                    sx={{
                        position: "absolute",
                        width: { xs: 250, md: 450 },
                        height: { xs: 250, md: 450 },
                        borderRadius: "50%",
                        background:
                            "radial-gradient(circle,rgba(35,139,73,0.08) 0%,rgba(35,139,73,0) 70%)",
                        bottom: -150,
                        right: -120,
                        pointerEvents: "none",
                    }}
                />

                <Container maxWidth="xl" sx={{ position: "relative" }}>
                    {/* PAGE HEADER */}
                    <Box
                        sx={{
                            textAlign: "center",
                            mb: { xs: 7, md: 9 },
                        }}
                    >
                        <Typography
                            sx={{
                                color: "#238B49",
                                fontWeight: 800,
                                letterSpacing: "5px",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                mb: 2,
                            }}
                        >
                            CriticalConquer
                        </Typography>

                        <Typography
                            sx={{
                                color: "#10271B",
                                fontWeight: 900,
                                fontSize: {
                                    xs: "42px",
                                    sm: "56px",
                                    md: "72px",
                                },
                                lineHeight: 1,
                                letterSpacing: "-2px",
                                mb: 2,
                            }}
                        >
                            DOWNLOAD & PLAY
                        </Typography>

                        <Typography
                            sx={{
                                color: "#238B49",
                                fontWeight: 900,
                                fontSize: {
                                    xs: "42px",
                                    sm: "56px",
                                    md: "72px",
                                },
                                lineHeight: 1,
                                letterSpacing: "-2px",
                            }}
                        >
                            YOUR NEXT ADVENTURE
                        </Typography>

                        <Box
                            sx={{
                                width: 90,
                                height: 3,
                                background:
                                    "linear-gradient(90deg,transparent,#55D878,transparent)",
                                mx: "auto",
                                my: 3,
                            }}
                        />

                        <Typography
                            sx={{
                                maxWidth: "720px",
                                mx: "auto",
                                color: "#526B59",
                                fontSize: {
                                    xs: "15px",
                                    md: "17px",
                                },
                                lineHeight: 1.9,
                            }}
                        >
                            Get your CriticalConquer client ready and step into a classic 5165 world
                            shaped by rivalries, guild loyalty, open battles, and
                            the kind of adventures worth coming back for.
                        </Typography>
                    </Box>

                    <Grid container spacing={5} alignItems="stretch">

                        {/* LEFT SIDE */}
                        <Grid item xs={12} lg={7}>

                            {/* MAIN DOWNLOAD CARD */}
                            <Paper
                                elevation={0}
                                sx={{
                                    position: "relative",
                                    overflow: "hidden",
                                    p: { xs: 3, md: 5 },
                                    borderRadius: "18px",
                                    background:
                                        "linear-gradient(145deg,#10271B,#09170F)",
                                    border:
                                        "1px solid rgba(65,190,105,0.45)",
                                    boxShadow:
                                        "0 20px 50px rgba(38,25,14,0.18)",
                                }}
                            >
                                {/* GOLD DECORATION */}
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "3px",
                                        background:
                                            "linear-gradient(90deg,transparent,#55D878,#B5FF9A,#55D878,transparent)",
                                    }}
                                />

                                <Box
                                    sx={{
                                        position: "absolute",
                                        width: 180,
                                        height: 180,
                                        borderRadius: "50%",
                                        border:
                                            "1px solid rgba(65,190,105,0.08)",
                                        top: -100,
                                        right: -70,
                                    }}
                                />

                                <Grid
                                    container
                                    spacing={3}
                                    alignItems="center"
                                >
                                    <Grid item xs={12} md={8}>
                                        <Typography
                                            sx={{
                                                color: "#55D878",
                                                fontSize: "12px",
                                                fontWeight: 800,
                                                letterSpacing: "3px",
                                                mb: 1.5,
                                            }}
                                        >
                                            YOUR GATEWAY TO THE WORLD
                                        </Typography>

                                        <Typography
                                            sx={{
                                                color: "#FFFFFF",
                                                fontWeight: 900,
                                                fontSize: {
                                                    xs: "30px",
                                                    md: "40px",
                                                },
                                                lineHeight: 1.1,
                                                mb: 2,
                                            }}
                                        >
                                            GET THE CLIENT
                                        </Typography>

                                        <Typography
                                            sx={{
                                                color: "#C1D3C5",
                                                lineHeight: 1.8,
                                                fontSize: "14px",
                                                maxWidth: "580px",
                                            }}
                                        >
                                            Install the client, prepare your gear, and meet your next challenge
                                            in a world inspired by the classic 5165 era.
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: {
                                                    xs: "flex-start",
                                                    md: "flex-end",
                                                },
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: 100,
                                                    height: 100,
                                                    borderRadius: "50%",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    background:
                                                        "radial-gradient(circle,#17452A,#10271B)",
                                                    border:
                                                        "1px solid rgba(65,190,105,0.45)",
                                                    boxShadow:
                                                        "0 0 35px rgba(65,190,105,0.12)",
                                                }}
                                            >
                                                <CloudDownloadIcon
                                                    sx={{
                                                        color: "#55D878",
                                                        fontSize: 52,
                                                    }}
                                                />
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>

                                <Divider
                                    sx={{
                                        my: 4,
                                        borderColor:
                                            "rgba(65,190,105,0.15)",
                                    }}
                                />

                                <Typography
                                    sx={{
                                        color: "#FFFFFF",
                                        fontWeight: 800,
                                        fontSize: "20px",
                                        mb: 1,
                                    }}
                                >
                                    Choose Your Download
                                </Typography>

                                <Typography
                                    sx={{
                                        color: "#9DB3A2",
                                        fontSize: "13px",
                                        mb: 3,
                                    }}
                                >
                                    Pick a download mirror and get ready to enter the world.
                                </Typography>

                                <Button
                                    fullWidth
                                    variant="contained"
                                    startIcon={<FlashOnIcon />}
                                    href="https://criticalconquer.site/files1/Critical%20Conquer%201.0%20-%20NEW%20SERVER.rar"
                                    target="_blank"
                                    onClick={this.handleDownload}
                                    sx={{
                                        py: 2,
                                        borderRadius: "10px",
                                        background:
                                            "linear-gradient(135deg,#238B49,#7FE89A,#238B49)",
                                        color: "#07170D",
                                        fontWeight: 900,
                                        textTransform: "none",
                                        fontSize: "16px",
                                        boxShadow:
                                            "0 8px 25px rgba(65,190,105,0.18)",
                                        "&:hover": {
                                            background:
                                                "linear-gradient(135deg,#32A95E,#B5FF9A,#32A95E)",
                                        },
                                    }}
                                >
                                    Start Download
                                </Button>

                                {isDownloading && (
                                    <Box sx={{ mt: 3 }}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "center",
                                                mb: 2,
                                            }}
                                        >
                                            <ClipLoader
                                                color="#55D878"
                                                size={30}
                                            />
                                        </Box>

                                        <LinearProgress
                                            variant="determinate"
                                            value={downloadProgress}
                                            sx={{
                                                height: 8,
                                                borderRadius: "2px",
                                                backgroundColor: "#193523",
                                                "& .MuiLinearProgress-bar": {
                                                    background:
                                                        "linear-gradient(90deg,#238B49,#B5FF9A)",
                                                },
                                            }}
                                        />

                                        <Typography
                                            sx={{
                                                color: "#9DB3A2",
                                                textAlign: "center",
                                                fontSize: "12px",
                                                mt: 1,
                                            }}
                                        >
                                            Preparing download...{" "}
                                            {downloadProgress}%
                                        </Typography>
                                    </Box>
                                )}
                            </Paper>

                            {/* MIRRORS */}
                            <Box sx={{ mt: 5 }}>
                                <Typography
                                    sx={{
                                        color: "#10271B",
                                        fontWeight: 900,
                                        fontSize: "25px",
                                        mb: 1,
                                    }}
                                >
                                    More Ways to Download
                                </Typography>

                                <Typography
                                    sx={{
                                        color: "#617363",
                                        fontSize: "14px",
                                        mb: 3,
                                    }}
                                >
                                    Choose another trusted mirror for your CriticalConquer game files.
                                </Typography>

                                <Grid container spacing={2}>

                                    {/* DIRECT */}
                                    <Grid item xs={12}>
                                        <Button
                                            fullWidth
                                            href="https://criticalconquer.site/files1/Critical%20Conquer%201.0%20-%20NEW%20SERVER.rar"
                                            target="_blank"
                                            startIcon={<FlashOnIcon />}
                                            sx={{
                                                py: 2,
                                                borderRadius: "10px",
                                                background:
                                                    "linear-gradient(135deg,#238B49,#55D878)",
                                                color: "#10271B",
                                                fontWeight: 900,
                                                textTransform: "none",
                                                fontSize: "15px",
                                                boxShadow:
                                                    "0 8px 20px rgba(168,121,26,0.15)",
                                                "&:hover": {
                                                    background:
                                                        "linear-gradient(135deg,#32A95E,#B5FF9A)",
                                                },
                                            }}
                                        >
                                            Direct Link — Fastest Route
                                        </Button>
                                    </Grid>

                                    {/* GOOGLE DRIVE */}
                                    <Grid item xs={12} sm={6}>
                                        <Button
                                            fullWidth
                                            href="https://drive.google.com/file/d/16JLJ60CtJSHIAHxvYXRvdq52htPV6c3K/view?usp=sharing"
                                            target="_blank"
                                            startIcon={<StorageIcon />}
                                            sx={{
                                                py: 2,
                                                borderRadius: "10px",
                                                background: "#FFFFFF",
                                                border:
                                                    "1px solid rgba(120,91,45,0.22)",
                                                color: "#203D2B",
                                                textTransform: "none",
                                                fontWeight: 800,
                                                boxShadow:
                                                    "0 6px 18px rgba(40,28,16,0.06)",
                                                "&:hover": {
                                                    background: "#F0FAEF",
                                                    border:
                                                        "1px solid rgba(168,121,26,0.45)",
                                                },
                                            }}
                                        >
                                            Google Drive Mirror
                                        </Button>
                                    </Grid>

                                    {/* MEGA */}
                                    <Grid item xs={12} sm={6}>
                                        <Button
                                            fullWidth
                                            href="https://mega.nz/file/zG4FXTLQ#qW4RkgEGDwEUkAx1E-rLeqZwlzCr-3CI0Esd8rojvVM"
                                            target="_blank"
                                            startIcon={<DownloadIcon />}
                                            sx={{
                                                py: 2,
                                                borderRadius: "10px",
                                                background: "#FFFFFF",
                                                border:
                                                    "1px solid rgba(120,91,45,0.22)",
                                                color: "#203D2B",
                                                textTransform: "none",
                                                fontWeight: 800,
                                                boxShadow:
                                                    "0 6px 18px rgba(40,28,16,0.06)",
                                                "&:hover": {
                                                    background: "#F0FAEF",
                                                    border:
                                                        "1px solid rgba(168,121,26,0.45)",
                                                },
                                            }}
                                        >
                                            MEGA Mirror
                                        </Button>
                                    </Grid>

                                    {/* MEDIAFIRE */}
                                    <Grid item xs={12}>
                                        <Button
                                            fullWidth
                                            href="https://www.mediafire.com/file/z65s9mc4x75nnw2/Critical+Conquer+1.0+-+NEW+SERVER.rar/file"
                                            target="_blank"
                                            startIcon={<CloudDownloadIcon />}
                                            sx={{
                                                py: 2,
                                                borderRadius: "10px",
                                                background: "#FFFFFF",
                                                border:
                                                    "1px solid rgba(120,91,45,0.22)",
                                                color: "#203D2B",
                                                textTransform: "none",
                                                fontWeight: 800,
                                                boxShadow:
                                                    "0 6px 18px rgba(40,28,16,0.06)",
                                                "&:hover": {
                                                    background: "#F0FAEF",
                                                    border:
                                                        "1px solid rgba(168,121,26,0.45)",
                                                },
                                            }}
                                        >
                                            MediaFire Mirror
                                        </Button>
                                    </Grid>

                                </Grid>
                            </Box>
                        </Grid>

                        {/* RIGHT SIDE */}
                        <Grid item xs={12} lg={5}>
                            <Paper
                                elevation={0}
                                sx={{
                                    height: "100%",
                                    minHeight: { lg: "590px" },
                                    position: "relative",
                                    overflow: "hidden",
                                    background:
                                        "linear-gradient(160deg,#0D2115,#153522,#09170F)",
                                    border:
                                        "1px solid rgba(65,190,105,0.35)",
                                    borderRadius: "18px",
                                    p: { xs: 4, md: 5 },
                                    boxShadow:
                                        "0 20px 55px rgba(38,25,14,0.16)",
                                }}
                            >
                                {/* RED DECORATION */}
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: 0,
                                        right: 0,
                                        width: "100%",
                                        height: "3px",
                                        background:
                                            "linear-gradient(90deg,transparent,#238B49,#B5FF9A,#238B49,transparent)",
                                    }}
                                />

                                <Box
                                    sx={{
                                        position: "absolute",
                                        width: 260,
                                        height: 260,
                                        borderRadius: "50%",
                                        border:
                                            "1px solid rgba(65,190,105,0.07)",
                                        top: -120,
                                        right: -110,
                                    }}
                                />

                                <Box
                                    sx={{
                                        position: "absolute",
                                        width: 180,
                                        height: 180,
                                        borderRadius: "50%",
                                        border:
                                            "1px solid rgba(35,139,73,0.12)",
                                        bottom: -90,
                                        left: -80,
                                    }}
                                />

                                <Box
                                    sx={{
                                        textAlign: "center",
                                        position: "relative",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: 120,
                                            height: 120,
                                            mx: "auto",
                                            mb: 3,
                                            borderRadius: "50%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            background:
                                                "radial-gradient(circle,#493318,#191310)",
                                            border:
                                                "1px solid rgba(65,190,105,0.4)",
                                            boxShadow:
                                                "0 0 40px rgba(65,190,105,0.1)",
                                        }}
                                    >
                                        <SecurityIcon
                                            sx={{
                                                fontSize: 58,
                                                color: "#55D878",
                                            }}
                                        />
                                    </Box>

                                    <Typography
                                        sx={{
                                            color: "#55D878",
                                            fontWeight: 800,
                                            letterSpacing: "3px",
                                            fontSize: "11px",
                                            mb: 2,
                                        }}
                                    >
                                        BUILT FOR CLASSIC PLAYERS
                                    </Typography>

                                    <Typography
                                        sx={{
                                            color: "#FFFFFF",
                                            fontWeight: 900,
                                            fontSize: {
                                                xs: "32px",
                                                md: "40px",
                                            },
                                            lineHeight: 1.1,
                                            mb: 3,
                                        }}
                                    >
                                        MAKE YOUR MARK
                                        <Box
                                            component="span"
                                            sx={{
                                                display: "block",
                                                color: "#55D878",
                                            }}
                                        >
                                            IN THE WORLD
                                        </Box>
                                    </Typography>

                                    <Typography
                                        sx={{
                                            color: "#A79E95",
                                            lineHeight: 1.9,
                                            fontSize: "14px",
                                            maxWidth: "430px",
                                            mx: "auto",
                                            mb: 5,
                                        }}
                                    >
                                        Train your character, find allies, challenge rivals, and carve out
                                        your own name in a world where every battle counts.
                                    </Typography>
                                </Box>

                                <Divider
                                    sx={{
                                        borderColor:
                                            "rgba(65,190,105,0.15)",
                                        mb: 4,
                                    }}
                                />

                                <Grid container spacing={2}>

                                    {/* 5165 */}
                                    <Grid item xs={12} sm={4}>
                                        <Paper
                                            elevation={0}
                                            sx={{
                                                p: 2.5,
                                                textAlign: "center",
                                                borderRadius: "10px",
                                                background:
                                                    "rgba(255,255,255,0.035)",
                                                border:
                                                    "1px solid rgba(65,190,105,0.14)",
                                            }}
                                        >
                                            <SpeedIcon
                                                sx={{
                                                    color: "#55D878",
                                                    fontSize: 34,
                                                    mb: 1,
                                                }}
                                            />

                                            <Typography
                                                sx={{
                                                    color: "#FFFFFF",
                                                    fontWeight: 900,
                                                    fontSize: "16px",
                                                }}
                                            >
                                                5165
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    color: "#A3B6A5",
                                                    fontSize: "12px",
                                                }}
                                            >
                                                Old-School
                                            </Typography>
                                        </Paper>
                                    </Grid>

                                    {/* FPS */}
                                    <Grid item xs={12} sm={4}>
                                        <Paper
                                            elevation={0}
                                            sx={{
                                                p: 2.5,
                                                textAlign: "center",
                                                borderRadius: "10px",
                                                background:
                                                    "rgba(255,255,255,0.035)",
                                                border:
                                                    "1px solid rgba(65,190,105,0.14)",
                                            }}
                                        >
                                            <FlashOnIcon
                                                sx={{
                                                    color: "#55D878",
                                                    fontSize: 34,
                                                    mb: 1,
                                                }}
                                            />

                                            <Typography
                                                sx={{
                                                    color: "#FFFFFF",
                                                    fontWeight: 900,
                                                    fontSize: "16px",
                                                }}
                                            >
                                                FPS
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    color: "#A3B6A5",
                                                    fontSize: "12px",
                                                }}
                                            >
                                                Responsive
                                            </Typography>
                                        </Paper>
                                    </Grid>

                                    {/* SECURITY */}
                                    <Grid item xs={12} sm={4}>
                                        <Paper
                                            elevation={0}
                                            sx={{
                                                p: 2.5,
                                                textAlign: "center",
                                                borderRadius: "10px",
                                                background:
                                                    "rgba(255,255,255,0.035)",
                                                border:
                                                    "1px solid rgba(65,190,105,0.14)",
                                            }}
                                        >
                                            <SecurityIcon
                                                sx={{
                                                    color: "#55D878",
                                                    fontSize: 34,
                                                    mb: 1,
                                                }}
                                            />

                                            <Typography
                                                sx={{
                                                    color: "#FFFFFF",
                                                    fontWeight: 900,
                                                    fontSize: "16px",
                                                }}
                                            >
                                                READY
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    color: "#A3B6A5",
                                                    fontSize: "12px",
                                                }}
                                            >
                                                Game Client
                                            </Typography>
                                        </Paper>
                                    </Grid>

                                </Grid>

                                {/* CLASSIC MESSAGE */}
                                <Box
                                    sx={{
                                        mt: 4,
                                        p: 3,
                                        textAlign: "center",
                                        background:
                                            "linear-gradient(135deg,rgba(35,139,73,0.22),rgba(181,255,154,0.07))",
                                        border:
                                            "1px solid rgba(85,216,120,0.28)",
                                        borderRadius: "10px",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: "#55D878",
                                            fontWeight: 900,
                                            fontSize: "13px",
                                            letterSpacing: "2px",
                                            mb: 1,
                                        }}
                                    >
                                        YOUR STORY STARTS WITH ONE STEP
                                    </Typography>

                                    <Typography
                                        sx={{
                                            color: "#A9BBAA",
                                            fontSize: "12px",
                                            lineHeight: 1.7,
                                        }}
                                    >
                                        Get set up, step into the battlefield, and make the adventure yours.
                                    </Typography>
                                </Box>
                            </Paper>
                        </Grid>
                    </Grid>

                    {/* BOTTOM NOTE */}
                    <Box
                        sx={{
                            mt: 7,
                            textAlign: "center",
                        }}
                    >
                        <Typography
                            sx={{
                                color: "#617363",
                                fontSize: "13px",
                            }}
                        >
                            For the smoothest experience, use the latest client version before
                            joining CriticalConquer.
                        </Typography>
                    </Box>
                </Container>
            </Box>
        );
    }
}

export default DownloadSection;